var _Array$prototype;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import * as cg from './types.js';
export var invRanks = _toConsumableArray(cg.ranks).reverse();
export var allKeys = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, _toConsumableArray(cg.files.map(function (c) {
  return cg.ranks.map(function (r) {
    return c + r;
  });
})));
export var pos2key = function pos2key(pos) {
  return allKeys[8 * pos[0] + pos[1]];
};
export var key2pos = function key2pos(k) {
  return [k.charCodeAt(0) - 97, k.charCodeAt(1) - 49];
};
export var uciToMove = function uciToMove(uci) {
  if (!uci) return undefined;
  if (uci[1] === '@') return [uci.slice(2, 4)];
  return [uci.slice(0, 2), uci.slice(2, 4)];
};
export var allPos = allKeys.map(key2pos);
export function memo(f) {
  var v;
  var ret = function ret() {
    if (v === undefined) v = f();
    return v;
  };
  ret.clear = function () {
    v = undefined;
  };
  return ret;
}
export var timer = function timer() {
  var startAt;
  return {
    start: function start() {
      startAt = performance.now();
    },
    cancel: function cancel() {
      startAt = undefined;
    },
    stop: function stop() {
      if (!startAt) return 0;
      var time = performance.now() - startAt;
      startAt = undefined;
      return time;
    }
  };
};
export var opposite = function opposite(c) {
  return c === 'white' ? 'black' : 'white';
};
export var distanceSq = function distanceSq(pos1, pos2) {
  var dx = pos1[0] - pos2[0],
    dy = pos1[1] - pos2[1];
  return dx * dx + dy * dy;
};
export var samePiece = function samePiece(p1, p2) {
  return p1.role === p2.role && p1.color === p2.color;
};
export var posToTranslate = function posToTranslate(bounds) {
  return function (pos, asWhite) {
    return [(asWhite ? pos[0] : 7 - pos[0]) * bounds.width / 8, (asWhite ? 7 - pos[1] : pos[1]) * bounds.height / 8];
  };
};
export var translate = function translate(el, pos) {
  el.style.transform = "translate(".concat(pos[0], "px,").concat(pos[1], "px)");
};
export var translateAndScale = function translateAndScale(el, pos) {
  var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  el.style.transform = "translate(".concat(pos[0], "px,").concat(pos[1], "px) scale(").concat(scale, ")");
};
export var setVisible = function setVisible(el, v) {
  el.style.visibility = v ? 'visible' : 'hidden';
};
export var eventPosition = function eventPosition(e) {
  var _a;
  if (e.clientX || e.clientX === 0) return [e.clientX, e.clientY];
  if ((_a = e.targetTouches) === null || _a === void 0 ? void 0 : _a[0]) return [e.targetTouches[0].clientX, e.targetTouches[0].clientY];
  return; // touchend has no position!
};
export var isRightButton = function isRightButton(e) {
  return e.button === 2;
};
export var createEl = function createEl(tagName, className) {
  var el = document.createElement(tagName);
  if (className) el.className = className;
  return el;
};
export function computeSquareCenter(key, asWhite, bounds) {
  var pos = key2pos(key);
  if (!asWhite) {
    pos[0] = 7 - pos[0];
    pos[1] = 7 - pos[1];
  }
  return [bounds.left + bounds.width * pos[0] / 8 + bounds.width / 16, bounds.top + bounds.height * (7 - pos[1]) / 8 + bounds.height / 16];
}